import React from 'react';

const colorMapping = {
  blue: [
    '#C3F5DB',
    '#C9ECFF',
    '#F8F8F8',
    '#FFC86E',
    '#47525D',
    '#80D2FF',
    '#42ACE6',
    '#42ACE6',
    '#80D2FF',
  ],
  green: [
    '#C3F5DB',
    '#BBEED4',
    '#F8F8F8',
    '#FFC86E',
    '#47525D',
    '#4AE193',
    '#31C87A',
    '#31C87A',
    '#4AE193',
  ],
  purple: [
    '#C3F5DB',
    '#CBD3FB',
    '#F8F8F8',
    '#FFC86E',
    '#47525D',
    '#8597F5',
    '#516BF0',
    '#516BF0',
    '#8597F5',
  ],
  red: [
    '#C3F5DB',
    '#FECFCF',
    '#F8F8F8',
    '#FFC86E',
    '#47525D',
    '#FE8E90',
    '#E45556',
    '#E45556',
    '#FE8E90',
  ],
  yellow: [
    '#C3F5DB',
    '#FFE4D0',
    '#F8F8F8',
    '#FFC86E',
    '#47525D',
    '#FFC192',
    '#E69559',
    '#E69559',
    '#FFC192',
  ],
};

export const avatarColors = Object.keys(colorMapping);
export const getColorAt = (i = 0) => avatarColors[i % 4];

const AvatarV1 = ({ color }) => {
  const colors = colorMapping[color];

  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <MaskPrimary id={`maskv1${color}`} />
      <g mask={`url(#maskv1${color})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
          fill={colors[1]}
        />
        <path
          d="M50.2069 48.2754H4.82764L22.6897 68.0685L50.2069 48.2754Z"
          fill={colors[2]}
        />
        <mask
          id={`mask1${color}`}
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="7"
          y="8"
          width="40"
          height="40"
        >
          <path
            d="M27.0345 47.3102C37.6993 47.3102 46.3448 38.6646 46.3448 27.9998C46.3448 17.335 37.6993 8.68945 27.0345 8.68945C16.3697 8.68945 7.72412 17.335 7.72412 27.9998C7.72412 38.6646 16.3697 47.3102 27.0345 47.3102Z"
            fill={colors[3]}
          />
          <path
            d="M27.0345 47.3102C37.6993 47.3102 46.3448 38.6646 46.3448 27.9998C46.3448 17.335 37.6993 8.68945 27.0345 8.68945C16.3697 8.68945 7.72412 17.335 7.72412 27.9998C7.72412 38.6646 16.3697 47.3102 27.0345 47.3102Z"
            stroke={colors[4]}
          />
        </mask>
        <g mask={`url(#mask1${color})`}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.0345 47.3102C37.6993 47.3102 46.3448 38.6646 46.3448 27.9998C46.3448 17.335 37.6993 8.68945 27.0345 8.68945C16.3697 8.68945 7.72412 17.335 7.72412 27.9998C7.72412 38.6646 16.3697 47.3102 27.0345 47.3102Z"
            fill={colors[5]}
          />
          <path
            d="M35.5957 18.0745C31.8647 19.2622 15.7888 24.5652 11.25 18.0745L-26.069 -3.20616L-2.23221 -29.9307L86.8965 -9.14494L44.9231 18.0745C43.3685 17.5796 39.3267 16.8867 35.5957 18.0745Z"
            fill={colors[6]}
          />
          <path
            d="M26.097 37.0214C26.3196 39.6623 24.5768 41.9652 22.2043 42.1652C19.8318 42.3652 17.728 40.3864 17.5054 37.7456L26.097 37.0214Z"
            fill={colors[7]}
          />
        </g>
        <path
          d="M22.2069 48.2758V46.3447H31.8621V48.2758C31.8621 50.942 29.7007 53.1033 27.0345 53.1033C24.3683 53.1033 22.2069 50.942 22.2069 48.2758Z"
          fill={colors[8]}
        />
      </g>
    </svg>
  );
};

const AvatarV2 = ({ color }) => {
  const colors = colorMapping[color];

  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <MaskPrimary id={`maskv2${color}`} />
      <g mask={`url(#maskv2${color})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
          fill={colors[1]}
        />
        <path
          d="M50.2069 48.2754H4.82764L22.6897 68.0685L50.2069 48.2754Z"
          fill={colors[2]}
        />
      </g>
      <mask
        id={`mask1${color}`}
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="8"
        y="8"
        width="40"
        height="40"
      >
        <path
          d="M28 47.3102C38.6649 47.3102 47.3104 38.6646 47.3104 27.9998C47.3104 17.335 38.6649 8.68945 28 8.68945C17.3352 8.68945 8.6897 17.335 8.6897 27.9998C8.6897 38.6646 17.3352 47.3102 28 47.3102Z"
          fill={colors[3]}
        />
        <path
          d="M28 47.3102C38.6649 47.3102 47.3104 38.6646 47.3104 27.9998C47.3104 17.335 38.6649 8.68945 28 8.68945C17.3352 8.68945 8.6897 17.335 8.6897 27.9998C8.6897 38.6646 17.3352 47.3102 28 47.3102Z"
          stroke={colors[4]}
        />
      </mask>
      <g mask={`url(#mask1${color})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.9997 49.3095C39.7689 49.3095 49.3097 39.7686 49.3097 27.9995C49.3097 16.2303 39.7689 6.68945 27.9997 6.68945C16.2305 6.68945 6.6897 16.2303 6.6897 27.9995C6.6897 39.7686 16.2305 49.3095 27.9997 49.3095Z"
          fill={colors[5]}
        />
        <path
          d="M28 35.7246C28 38.3908 25.8386 40.5522 23.1724 40.5522C20.5062 40.5522 18.3448 38.3908 18.3448 35.7246H28Z"
          fill={colors[6]}
        />
        <path
          d="M19.899 19.42C16.6684 22.8045 11.0901 23.4303 8.36787 23.267L-2.23389 17.5875L23.8919 -6.07715H52.6681L59.4835 34.626L40.5518 46.553V24.9167C40.5518 24.1657 39.7479 23.6765 39.0434 23.9365C32.3073 26.4229 25.3714 22.5059 22.5118 19.4553C21.9163 18.82 20.5002 18.7901 19.899 19.42Z"
          fill={colors[7]}
        />
      </g>
      <path
        d="M22.2069 48.2758V46.3447H31.8621V48.2758C31.8621 50.942 29.7007 53.1033 27.0345 53.1033C24.3683 53.1033 22.2069 50.942 22.2069 48.2758Z"
        fill={colors[8]}
      />
    </svg>
  );
};

const AvatarV3 = ({ color }) => {
  const colors = colorMapping[color];

  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <MaskPrimary id={`maskv3${color}`} />
      <g mask={`url(#maskv3${color})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
          fill={colors[1]}
        />
        <path
          d="M50.2069 48.2754H4.82764L22.6897 68.0685L50.2069 48.2754Z"
          fill={colors[2]}
        />
        <mask
          id={`mask1${color}`}
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="7"
          y="8"
          width="40"
          height="40"
        >
          <path
            d="M27.0345 47.3102C37.6993 47.3102 46.3448 38.6646 46.3448 27.9998C46.3448 17.335 37.6993 8.68945 27.0345 8.68945C16.3697 8.68945 7.72412 17.335 7.72412 27.9998C7.72412 38.6646 16.3697 47.3102 27.0345 47.3102Z"
            fill={colors[3]}
          />
          <path
            d="M27.0345 47.3102C37.6993 47.3102 46.3448 38.6646 46.3448 27.9998C46.3448 17.335 37.6993 8.68945 27.0345 8.68945C16.3697 8.68945 7.72412 17.335 7.72412 27.9998C7.72412 38.6646 16.3697 47.3102 27.0345 47.3102Z"
            stroke={colors[4]}
          />
        </mask>
        <g mask={`url(#mask1${color})`}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.0345 47.3102C37.6993 47.3102 46.3448 38.6646 46.3448 27.9998C46.3448 17.335 37.6993 8.68945 27.0345 8.68945C16.3697 8.68945 7.72412 17.335 7.72412 27.9998C7.72412 38.6646 16.3697 47.3102 27.0345 47.3102Z"
            fill={colors[5]}
          />
          <path
            d="M29.0338 19.5434C23.1786 26.1968 11.3739 23.9354 8.68965 21.2416L3.86206 17.7928L33.2896 -8.68945H65.7025L73.3793 36.86L60.9579 50.2071L49.2179 27.4426C48.9644 26.951 48.3611 26.7629 47.8527 26.9807C39.962 30.3601 33.6902 23.802 31.2533 19.731C30.8154 18.9994 29.597 18.9034 29.0338 19.5434Z"
            fill={colors[6]}
          />
          <path
            d="M25.1367 37.1024C25.3143 39.2097 23.75 41.062 21.6427 41.2396C19.5354 41.4172 17.6831 39.8529 17.5054 37.7456L25.1367 37.1024Z"
            fill={colors[7]}
          />
        </g>
        <path
          d="M22.2069 48.2758V46.3447H31.8621V48.2758C31.8621 50.942 29.7007 53.1033 27.0345 53.1033C24.3683 53.1033 22.2069 50.942 22.2069 48.2758Z"
          fill={colors[8]}
        />
      </g>
    </svg>
  );
};

const AvatarV4 = ({ color }) => {
  const colors = colorMapping[color];

  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <MaskPrimary id={`maskv4${color}`} />
      <g mask={`url(#maskv4${color})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
          fill={colors[1]}
        />
        <path
          d="M50.2069 48.2754H4.82758L22.6896 68.0685L50.2069 48.2754Z"
          fill="#F8F8F8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 47.3101C38.6648 47.3101 47.3103 38.6646 47.3103 27.9998C47.3103 17.335 38.6648 8.68945 28 8.68945C17.3352 8.68945 8.68964 17.335 8.68964 27.9998C8.68964 38.6646 17.3352 47.3101 28 47.3101Z"
          fill={colors[5]}
        />
        <path
          d="M28 35.7246C28 38.3908 25.8386 40.5522 23.1724 40.5522C20.5062 40.5522 18.3448 38.3908 18.3448 35.7246H28Z"
          fill={colors[6]}
        />
        <path
          d="M12.1134 48.2759C9.40994 45.9587 10.9869 41.3564 12.1134 39.1035C12.7571 40.23 14.6237 41.9035 16.941 43.4483C19.2582 44.9932 21.7686 46.0231 22.7341 46.3449L23.6996 48.2759H12.1134Z"
          fill={colors[6]}
        />
        <path
          d="M9.69065 25.0795C17.3108 24.7088 21.8512 20.1286 24.1012 15.8116C24.5189 15.0103 25.7992 14.9626 26.2644 15.7372C29.3118 20.8112 35.2183 26.1435 42.5957 26.5294C43.0863 26.555 43.5087 26.912 43.5664 27.3999C44.9119 38.7762 35.8993 44.7857 29.931 46.8275V48.2758H46.3448C47.4712 40.5517 49.2097 27.8261 45.862 20.7588C44.4137 16.5749 38.5241 5.88962 26.5517 6.27582C15.0363 6.64729 9.14809 15.683 8.71536 24.1044C8.68702 24.656 9.13902 25.1063 9.69065 25.0795Z"
          fill={colors[6]}
        />
        <path
          d="M22.2069 46.3451V44.4141H31.8621V46.3451C31.8621 49.0113 29.7007 51.1727 27.0345 51.1727C24.3683 51.1727 22.2069 49.0113 22.2069 46.3451Z"
          fill={colors[5]}
        />
      </g>
    </svg>
  );
};

const MaskPrimary = ({ id }) => (
  <mask
    id={id}
    mask-type="alpha"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="56"
    height="56"
  >
    <path
      d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
      fill="#C3F5DB"
    />
    <path
      d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
      stroke="#47525D"
    />
  </mask>
);
const avatars = [null, AvatarV1, AvatarV2, AvatarV3, AvatarV4];
const DEFAULT_VARIANT = 1;
const DEFAULT_COLOUR = 'blue';

export const AnonAvatar = ({ color, variant }) => {
  const Avatar = avatars[variant] || avatars[DEFAULT_VARIANT];

  return <Avatar color={color || DEFAULT_COLOUR} />;
};
